import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Footer = () => {
  const quickLinks = [
    { name: 'About Us', href: '/about' },
    { name: 'Our Program', href: '/program' },
    { name: 'Health & Safety', href: '/health-safety' },
    { name: 'Camera Policy', href: '/cameras' },
    { name: 'Enrollment', href: '/enroll' },
    { name: 'Contact Us', href: '/contact' },
  ];

  return (
    <footer className="bg-navy-primary text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/images/logo.png" 
                alt="Maple Kids Academy" 
                className="h-10 w-10 rounded-full"
              />
              <div>
                <h3 className="text-lg font-semibold">Maple Kids Academy</h3>
                <p className="text-sm text-gray-300">Licensed Group Childcare</p>
              </div>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              Providing nurturing, respectful care for children under 36 months in Maple Ridge. 
              We believe in creating a warm, secure environment where every child can thrive.
            </p>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contact Information</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="h-4 w-4 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-sm">10681 248 St</p>
                  <p className="text-sm">Maple Ridge, BC, Canada</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <p className="text-sm">info@mkids.ca</p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <p className="text-sm">Call for tour scheduling</p>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Operating Hours</h3>
            <div className="space-y-2">
              <div className="flex items-center space-x-3">
                <Clock className="h-4 w-4 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium">Monday - Friday</p>
                  <p className="text-sm text-gray-300">7:00 AM - 5:00 PM</p>
                </div>
              </div>
              <p className="text-xs text-gray-400 mt-2">
                Closed weekends and statutory holidays
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Quick Links</h3>
            <div className="grid grid-cols-1 gap-2">
              {quickLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col space-y-6">
            {/* Inclusivity Message */}
            <div className="text-center">
              <p className="text-sm text-gray-300 mb-2">
                We welcome all children regardless of abilities, background, or developmental needs.
              </p>
              <p className="text-xs text-gray-400">
                Licensed by Fraser Health • Committed to inclusive, respectful care
              </p>
            </div>
            
            {/* Copyright & Credits */}
            <div className="flex flex-col sm:flex-row justify-between items-center pt-4 border-t border-gray-700/50 space-y-3 sm:space-y-0">
              <p className="text-xs text-gray-400">
                &copy; 2025 Maple Kids Academy. All rights reserved.
              </p>
              <a 
                href="https://www.averoan.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-xs text-gray-400 hover:text-white transition-colors flex items-center space-x-1"
              >
                <span>Powered by</span>
                <span className="font-semibold text-purple-400 hover:text-purple-300">Averoan Technologies Inc.</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;